import { ExperimentOutcome } from "@/http/api-types";

export type ExperimentOutcomeOption = {
  value: ExperimentOutcome;
  label: string;
  description: string;
  badgeVariant: "outcome_positive" | "outcome_negative" | "outcome_neutral" | "outcome_inconclusive";
};

export const EXPERIMENT_OUTCOME_OPTIONS: ExperimentOutcomeOption[] = [
  {
    value: ExperimentOutcome.SignificantlyPositive,
    label: "Significantly positive",
    description:
      "The experiment delivered a meaningful and statistically reliable improvement versus control. We should roll this change out broadly.",
    badgeVariant: "outcome_positive",
  },
  {
    value: ExperimentOutcome.SignificantlyNegative,
    label: "Significantly negative",
    description:
      "The experiment caused a meaningful and statistically reliable decline versus control. We should not roll this change out.",
    badgeVariant: "outcome_negative",
  },
  {
    value: ExperimentOutcome.FlatNeutral,
    label: "Flat/neutral",
    description:
      "The experiment showed no meaningful difference versus control. A rollout decision should be based on operational or strategic reasons, not performance lift.",
    badgeVariant: "outcome_neutral",
  },
  {
    value: ExperimentOutcome.Inconclusive,
    label: "Inconclusive",
    description:
      "The data is insufficient or too noisy to make a reliable decision. Extend, redesign, or rerun the experiment before deciding.",
    badgeVariant: "outcome_inconclusive",
  },
];

const EXPERIMENT_OUTCOME_OPTIONS_BY_VALUE: Record<ExperimentOutcome, ExperimentOutcomeOption> = {
  [ExperimentOutcome.SignificantlyPositive]: EXPERIMENT_OUTCOME_OPTIONS[0],
  [ExperimentOutcome.SignificantlyNegative]: EXPERIMENT_OUTCOME_OPTIONS[1],
  [ExperimentOutcome.FlatNeutral]: EXPERIMENT_OUTCOME_OPTIONS[2],
  [ExperimentOutcome.Inconclusive]: EXPERIMENT_OUTCOME_OPTIONS[3],
};

export function getExperimentOutcomeOption(
  outcome: ExperimentOutcome | undefined,
): ExperimentOutcomeOption | undefined {
  if (!outcome) {
    return undefined;
  }
  return EXPERIMENT_OUTCOME_OPTIONS_BY_VALUE[outcome];
}
